module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/FreeIssue-LetterSantaClous.aff27df3.png";